document.addEventListener('DOMContentLoaded', () => {

  const nav = document.querySelector('.header__inline-menu .list-menu--inline');

  if (!nav) return;

  const moreItem = nav.querySelector('.menu-overflow-item');
  const moreMenu = moreItem.querySelector('.list-menu');

  const resizeObserver = new ResizeObserver(updateMenu);
  resizeObserver.observe(nav);

  window.addEventListener('resize', updateMenu);

  function updateMenu() {

    // Reset
    const overflowedItems = moreMenu.querySelectorAll(':scope > li');

    overflowedItems.forEach(item => {
      nav.insertBefore(item, moreItem);
    });

    moreItem.classList.add('hidden');

    const navWidth = nav.offsetWidth;
    let usedWidth = moreItem.offsetWidth;

    const items = [...nav.children].filter(item =>
      item !== moreItem
    );

    for (const item of items) {
      usedWidth += item.offsetWidth;

      if (usedWidth > navWidth) {

        moreItem.classList.remove('hidden');

        moreMenu.appendChild(item);
      }
    }

    // AFTER initial overflow calculation
    requestAnimationFrame(() => {
      const moreTop = moreItem.offsetTop;

      // If "More" wrapped to a new line
      const firstRowTop = items.length
        ? items[0].offsetTop
        : moreTop;

      if (moreTop > firstRowTop) {

        // Pull one more item into overflow
        const visibleItems = [...nav.children].filter(i =>
          i !== moreItem
        );

        const lastVisible = visibleItems[visibleItems.length - 1];

        if (lastVisible) {
          moreMenu.appendChild(lastVisible);
          moreItem.classList.remove('hidden');
        }
      }
    });

  }

  updateMenu();
});